import useSWR, { SWRResponse } from 'swr';
import { useLocale } from '@hooks/useLocale';
import { HookError } from '../../errorHandlers';
import type { Address } from '../../types/address';
import type { BigCommerceLocaleString } from '../../types/locale';

export const getAddressFetcher = async (
  url: string,
  locale: BigCommerceLocaleString
): Promise<Address[]> => {
  const addressResponse = await fetch(url, {
    headers: {
      'Accept-Language': locale,
    },
  });
  const {
    data: { addresses },
  } = await addressResponse.json();
  return addresses ?? [];
};

const useAddresses = (): SWRResponse<Address[], any> => {
  const locale = useLocale();
  if (!locale) throw new HookError('Locale must be specified to login');
  const swrAddressResponse = useSWR<Address[]>(
    [`/api/customer/addresses`, locale],
    getAddressFetcher,
    {
      revalidateOnFocus: false,
    }
  );
  return swrAddressResponse;
};

export default useAddresses;
